<header class="topbar">
  <div class="topbar-left">
    <button
      class="menu-toggle"
      (click)="onToggleMenu()"
      aria-label="Toggle sidebar"
      type="button"
    >
      <i class="pi pi-bars"></i>
    </button>

    <div class="brand">
      <div class="brand-logo">
        <i class="pi pi-shield"></i>
      </div>
      <div class="brand-text">
        <h1 class="brand-title">{{ brand.shortName }}</h1>
        <p class="brand-subtitle">Database Console</p>
      </div>
    </div>
  </div>

  <div class="topbar-center">
    <div class="search-placeholder">
      <i class="pi pi-search"></i>
      <span>Search across platform...</span>
    </div>
  </div>

  <div class="topbar-right">
    <button
      class="theme-toggle"
      type="button"
      (click)="onToggleTheme()"
      [attr.aria-label]="getThemeLabel()"
      [attr.title]="getThemeLabel()"
      [class.theme-toggle-dark]="isDarkMode()"
      [class.theme-toggle-system]="themeModeValue() === 'system'"
    >
      <span class="theme-toggle-track">
        <span class="theme-toggle-thumb">
          <i
            class="pi"
            [class.pi-desktop]="themeModeValue() === 'system'"
            [class.pi-moon]="themeModeValue() !== 'system' && !isDarkMode()"
            [class.pi-sun]="themeModeValue() !== 'system' && isDarkMode()"
          ></i>
        </span>
      </span>
    </button>

    <button
      class="profile-avatar"
      type="button"
      (click)="menu.toggle($event)"
      aria-label="User menu"
    >
      <span class="avatar-initials">{{ user()?.name?.charAt(0) || 'U' }}</span>
    </button>

    <p-menu
      #menu
      [model]="menuItems"
      [popup]="true"
      appendTo="body"
    />
  </div>
</header>
